import styled, { css } from 'styled-components';

import { SIDEBAR_WIDTH } from './constants';

import { color, viewPortWithoutHeader } from 'theme/selectors';
import mediaQueries from 'theme/mediaQueries';

export const SideBarMenu = styled.div`
    position: absolute;
    top: 0;
    left: -100%;
    width: ${SIDEBAR_WIDTH}px;
    height: 100%;
    box-shadow: 0 4px 12px rgb(0 0 0 / 12%);
    background: ${color('surface-default')};
    transition: all 0.3s;
`;

export const SideBarOverlay = styled.div`
    width: 100vw;
    height: 100vh;
    background: ${color('surface-main')};
    opacity: 0;
    transition: opacity 0.4s ease;
`;

export const SideBarWrapper = styled.div<{ $isOpen: boolean }>`
    position: fixed;
    top: 56px;
    left: 0;
    height: ${viewPortWithoutHeader()};
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s;
    z-index: 10001;

    ${mediaQueries.tabletLandscape} {
        opacity: 1;
        visibility: visible;

        ${SideBarMenu} {
            left: 0;
        }

        ${SideBarOverlay} {
            display: none;
        }
    }

    ${({ $isOpen }) =>
        $isOpen &&
        css`
            ${mediaQueries.mobile} {
                opacity: 1;
                visibility: visible;

                ${SideBarOverlay} {
                    opacity: 0.8;
                    visibility: visible;
                }

                ${SideBarMenu} {
                    left: 0;
                }
            }
        `}
`;

export const Hr = styled.div`
    margin-top: 28px;
    width: 100%;
    min-height: 1px;
    background-color: ${color('border-default')};
`;

const commonSecondaryButtonStyles = css`
    display: table;
    margin-bottom: 24px;
    padding-left: 12px;
    cursor: pointer;
    &:hover {
        * {
            color: ${color('text-secondary')};
        }
    }
`;

export const LinkSecondary = styled.a`
    ${commonSecondaryButtonStyles}
`;

export const NavSecondaryButton = styled.button`
    ${commonSecondaryButtonStyles}
`;

export const NavButton = styled.div<{ $isActive?: boolean }>`
    display: flex;
    width: 100%;
    text-align: left;
    align-items: center;
    cursor: pointer;
    position: relative;
    margin-bottom: 12px;
    padding: 12px 12px;
    border-radius: 8px;

    svg {
        margin-right: 6px;
    }

    &:hover {
        background: ${({ theme }) => color('surface-hovered')({ theme })};
    }

    ${({ $isActive, theme }) =>
        $isActive &&
        css`
            background: ${color('surface-hovered')({ theme })};

            &:before {
                background-color: ${color('primary-default')};
                border-radius: 0 4px 4px 0;
                content: '';
                height: 28px;
                left: 0;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                width: 2px;
            }

            svg * {
                fill: #fff;
            }
        `}
`;
